import { render, staticRenderFns } from "./Curvometer.vue?vue&type=template&id=72b32a1c&scoped=true&"
import script from "./Curvometer.vue?vue&type=script&lang=ts&"
export * from "./Curvometer.vue?vue&type=script&lang=ts&"
import style0 from "./Curvometer.vue?vue&type=style&index=0&id=72b32a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b32a1c",
  null
  
)

export default component.exports